import { HomePage } from 'components/main-page/home-page/HomePage'
import { HOME_PAGE_TAB_LIST } from 'constants/constant'
import { MiniBannerContainer } from './mini-banner/MiniBannerContainer'
import { MainBannerContainer } from './main-banner/MainBannerContainer'
import { PromoBannerContainer } from './promo-banner/PromoBannerContainer'
import { FlashSaleContainer } from './flash-sale/FlashSaleContainer'
import { SpecialPromoContainer } from './special-promo/SpecialPromoContainer'
import { DailyDealsContainer } from './daily-deals/DailyDealsContainer'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { BestDealsContainer } from './best-deals/BestDealsContainer'
import { ProductByCategoryContainer } from './product-by-category/ProductByCategoryContainer'
import { BestSellerContainer } from './best-seller/BestSellerContainer'
import { ClaimProductContainer } from './claim-product/ClaimProductContainer'
import { InstagramContainer } from './instagram/InstagramContainer'
import { SEOContainer } from './seo/SEOContainer'

const TAB_CONTENT = {
    'mini banner': <MiniBannerContainer />,
    'main banner': <MainBannerContainer />,
    'promo banner': <PromoBannerContainer />,
    'flash sale': <FlashSaleContainer />,
    'special promo': <SpecialPromoContainer />,
    'daily deals': <DailyDealsContainer />,
    'best deals': <BestDealsContainer />,
    'product by category': <ProductByCategoryContainer />,
    'best seller': <BestSellerContainer />,
    'claim product': <ClaimProductContainer />,
    instagram: <InstagramContainer />,
    SEO: <SEOContainer />,
}

export const HomePageContainer = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const sectionName = searchParams.get('sectionName')

    const onChangeSidebar = (item) => {
        navigate(`/main-page/home-page?sectionName=${item}`)
    }

    const props = {
        options: HOME_PAGE_TAB_LIST,
        content: TAB_CONTENT,
        activeSidebar: sectionName || 'mini banner',
        onChangeSidebar,
    }

    return <HomePage {...props} />
}
